// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-right-start-on-rectangle.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/arrow-right-start-on-rectangle'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowRightStartOnRectangleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
